<template>
  <div>
    <template v-if="getPoint('train').length > 0">
      <h2 class="mt-4 mb-1 font-bold text-sm">駅</h2>
      <div class="bg-gray-light border border-link rounded">
        <ul>
          <li v-for="(point, index) in getPoint('train')" v-bind:key="index">
            <div @click="selectPoint(point)" class="list-item px-4">
              <img :src="icon(point)" class="mr-2 h-6 w-6 flex-shrink-0">
              <span class="flex-grow">{{ point.Station.Name }}</span>
            </div>
          </li>
        </ul>
      </div>
    </template>
    <template v-if="getPoint('bus').length > 0">
      <h2 class="mt-4 mb-1 font-bold text-sm">バス停</h2>
      <div class="bg-gray-light border border-link rounded">
        <ul>
          <li v-for="(point, index) in getPoint('bus')" v-bind:key="index">
            <div @click="selectPoint(point)" class="list-item px-4">
              <img :src="icon(point)" class="mr-2 h-6 w-6 flex-shrink-0">
              <span class="flex-grow">{{ point.Station.Name }}</span>
            </div>
          </li>
        </ul>
      </div>
    </template>
    <template v-if="!isStationOnly && googlePlaces.length > 0">
      <h2 class="mt-4 mb-1 font-bold text-sm">施設・住所</h2>
      <div class="bg-gray-light border border-link rounded">
        <ul>
          <li v-for="(place, index) in googlePlaces" v-bind:key="index">
            <div @click="selectPlace(place)" class="list-item px-4">
              <div>
                <p>{{ place.name }}</p>
                <p class="text-sm text-body-lighter">{{ place.address }}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    searchWord: {
      type: String,
      required: true
    },
    searchType: {
      type: String,
      required: false
    },
    isStationOnly: {
      type: Boolean,
      default: false
    }
  },
  created: function () {
    setInterval(()=>{
      if(this.oldInput !== this.searchWord){
        this.oldInput = this.searchWord
        this.search(this.searchWord)
      }
    }, 100)
  },
  data () {
    return {
      oldInput: ""
    }
  },
  computed: {
    ...mapGetters({
      googlePlaces: 'googleMap/getPlaces',
      points: 'points/getPoints',
    })
  },
  methods: {
    selectPlace: function (place) {
      this.$store.dispatch('history/add', place)
      this.$emit('openPlace', place)
    },
    selectPoint: function (point) {
      const place = {
        isEkispertPlace: true,
        isGooglePlace: false,
        location: {
          latitude: parseFloat(point.GeoPoint.lati_d),
          longitude: parseFloat(point.GeoPoint.longi_d)
        },
        name: point.Station.Name,
        type: point.Station.Type.text !== undefined ? point.Station.Type.text : point.Station.Type,
        stationCode: point.Station.code
      }
      this.$store.dispatch('history/add', place)
      this.$emit('openPlace', place)
    },
    search: function (word) {
      this.$store.dispatch('points/fetchPoints', word)
      this.$store.dispatch('googleMap/fetchPlaces', word)
    },
    icon: function (point) {
      const type = point.Station.Type.text !== undefined ? point.Station.Type.text : point.Station.Type
      switch (type) {
        case "train":
          return require('@/assets/images/icon/train_black_24dp.svg')
        case "plane":
          return require('@/assets/images/icon/local_airport_black_24dp.svg')
        case "ship":
          return require('@/assets/images/icon/directions_boat_black_24dp.svg')
        case "bus":
          return require('@/assets/images/icon/airport_shuttle.svg')
      }
    },
    getPoint (type) {
      return this.points.filter(p => p.Station.Type === type || p.Station.Type.text === type)
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  @apply py-3 border-b border-gray-default flex items-center text-body-light;
}

ul li:last-of-type .list-item {
  @apply border-0;
}
</style>